import React, {FC, useEffect, useMemo, useState} from "react";
import {transactionService} from "../../../store/actions";
import {Link, useParams} from "react-router-dom";
import BTable from "../../../components/b-table";
import useCommon from "../../../common/hooks/useCommon";
import {formatUnit, serializeQuery, toXDCNumber,} from "../../../common/utils/function";
import AddressName from "../../common/address-name";
import {useTranslation} from "react-i18next";
import TokenImage from "../../common/token-image";

interface TransactionStateProps {
}

interface TransactionStateData {
}

const TransactionState: FC<TransactionStateProps> = (props) => {
    const {hash} = useParams();
    const {getXDC, get0x} = useCommon();
    const {t, i18n} = useTranslation();

    const [transactionList, setTransactionList] = useState<TransactionStateData[]>([]);
    const [loading, setLoading] = useState(true);
    const [pageParams, setPageParams] = useState<any>([null]);
    const [pageIndex, setPageIndex] = useState<any>(0);
    const getBlocks = async () => {
        try {
            setLoading(true);
            transactionService.getTransactionState(hash, serializeQuery(pageParams[pageIndex])).then((response) => {
                setTransactionList(response?.items);
                setPageParams((prevState: any) => {
                    prevState[pageIndex + 1] = response?.next_page_params;
                    return prevState;
                });
                setLoading(false);
            }).catch((e) => setLoading(false));
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        getBlocks();
    }, [pageIndex]);
    const header = useMemo(() => {
        return [
            {
                title: `${t("Address")}`,
                param: "address",
                headerStyle: {minWidth: "140px"},
                copy: (data: any) => getXDC(data?.address?.hash),
                tooltip: (data: any) => <Link to={`/address/${get0x(data?.address?.hash)}`}>{getXDC(data?.address?.hash)}</Link>,
                render: (data: any) => (<React.Fragment><Link to={`/address/${get0x(data?.address?.hash)}`}><AddressName data={data?.address}/></Link>
                    {data?.is_miner && <span
                        className="badge bg-secondary bg-opacity-10 border border-secondary border-opacity-25 text-dark fw-medium text-start text-wrap  px-2 me-2">Producer</span>}
                </React.Fragment>)
            },
            {
                title: `${t("Before")}`,
                param: "value",
                tooltip: true,
                render: (data: any) => (<React.Fragment>{data?.balance_before ? formatUnit(toXDCNumber(data?.balance_before, 18, 6)) : "-"}
                    {data?.nonce && (<div className="mb-0"><span
                        className="badge bg-secondary bg-opacity-10 border border-secondary border-opacity-25 text-dark fw-medium text-start text-wrap  px-2 me-2">Nonce: {data?.nonce}</span>
                    </div>)}
                </React.Fragment>)
            },
            {
                title: `${t("After")}`,
                param: "value",
                tooltip: true,
                render: (data: any) => (<React.Fragment> {data?.balance_after ? formatUnit(toXDCNumber(data?.balance_after, 18, 6)) : "-"}
                    {data?.nonce && (<div className="mb-0"><span
                        className="badge bg-secondary bg-opacity-10 border border-secondary border-opacity-25 text-dark fw-medium text-start text-wrap  px-2 me-2">Nonce: {data?.nonce}</span>
                    </div>)}
                </React.Fragment>)
            },
            {
                title: `${t("State Diffrence")}`,
                param: "gas_price",
                tooltip: true,
                render: (data: any) => (
                    <div className={`${data?.change < 0 ? "red" : "green"}`}>
                        {data?.change < 0 ? <i className="bi bi-caret-down-fill red"></i> : <i className="bi bi-caret-up-fill green"></i>}{" "}
                        &nbsp;
                        {toXDCNumber(data?.change * (data?.change < 0 ? -1 : 1), 18, 6)}
                    </div>
                ),
            },
            {
                title: `${t("Token")}`,
                param: "token",
                tooltip: true,
                render: (data: any) =>
                    !!data?.token && (
                        <p className="text-truncate">
                            <Link to={`/token/${data?.token?.address}`} className="d-flex align-items-center">
                                <TokenImage image={data?.token?.icon_url} symbol={data?.token?.symbol} params={{width: 20, className: "me-1"}}/>\
                                {data?.token?.name} ({data?.token?.symbol})
                            </Link>
                        </p>
                    ),
            },
        ];
    }, []);
    return (
        <BTable
            title={t("Transactions")}
            header={header}
            list={transactionList}
            loading={loading}
            pageIndex={pageIndex}
            setPageIndex={setPageIndex}
        />
    );
};

export default TransactionState;
